import Grid from 'components/core/Grid';
import { FormikAppEmailCheckTaken } from 'components/formik/core/FormikAppEmail/FormikAppEmail';

import { FormikAppTextField } from 'components/formik/core/FormikAppTextField/FormikAppTextField';
import { AppRoutes } from 'config/appRoutes';
import { useFormikContext } from 'formik';

export const ListPageUserFormInputs = () => {
  const { values } = useFormikContext<any>();

  return (
    <>
      <Grid item xs={12}>
        <FormikAppEmailCheckTaken name="email" loginRoute={AppRoutes.loginHost} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormikAppTextField name="firstName" label={'First Name'} disabled={values.is_email_taken} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormikAppTextField name="lastName" label={'Last Name'} disabled={values.is_email_taken} />
      </Grid>
    </>
  );
};
